module.exports = __webpack_public_path__ + "img/error.6046f0c8.png";